import type { ToastContent } from '@repo/components/toast';
import { ToastQueue } from '@repo/components/toast';

export const toastQueue = new ToastQueue<ToastContent>();
